import { simulatorAPI } from '../../../services/api';

/** @type {import('./voFlexTechCatalogMatch').VoFlexCatalogRow[] | null} */
let cachedCatalog = null;
/** @type {Promise<import('./voFlexTechCatalogMatch').VoFlexCatalogRow[] | null> | null} */
let inflight = null;

/**
 * Load active VO flex tech catalog (cached). Returns null on failure.
 * @returns {Promise<import('./voFlexTechCatalogMatch').VoFlexCatalogRow[] | null>}
 */
export function ensureVoFlexTechCatalogLoaded() {
  if (cachedCatalog) {
    return Promise.resolve(cachedCatalog);
  }
  if (!inflight) {
    inflight = simulatorAPI
      .getVoFlexTechCatalog()
      .then((res) => {
        if (res?.success && Array.isArray(res.catalog) && res.catalog.length > 0) {
          cachedCatalog = res.catalog;
          return cachedCatalog;
        }
        return null;
      })
      .catch(() => null)
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

export function prefetchVoFlexTechCatalog() {
  return ensureVoFlexTechCatalogLoaded();
}

/** @returns {import('./voFlexTechCatalogMatch').VoFlexCatalogRow[] | null} */
export function getCachedVoFlexTechCatalog() {
  return cachedCatalog;
}
